<div class="flex-row">
    <div id="customerReceipt" *ngIf="customer && customer.Lines && customer.Lines.length">
        <ng-container *ngFor="let line of customer.Lines">
            <div *ngIf="isHeader(line)" class="lm-active-order-details-field-block c-block">
                <div class="lm-active-order-details-field-value font-bold">{{ line.DisplayName }}</div>
            </div>
            <div *ngIf="!isHeader(line)" class="lm-active-order-details-field-block lm-active-order-details-field-block--amount"
                 [class.lm-active-order-details-field-block--indented]="isIndented(line)">
                <div class="lm-active-order-details-field-name"
                     [ngStyle]="{ 'font-weight': isTotal(line) ? '600' : '' }">{{ line.DisplayName }}:</div>
                <div class="lm-active-order-details-field-value"
                     [ngStyle]="{ 'font-weight': isTotal(line) ? '600' : '' }">{{ formatAmount(line) }}</div>
            </div>
        </ng-container>
    </div>

    <div id="riderReceipt" *ngIf="driver && driver.Lines && driver.Lines.length">
        <ng-container *ngFor="let line of driver.Lines">
            <div *ngIf="isHeader(line)" class="lm-active-order-details-field-block c-block">
                <div class="lm-active-order-details-field-value font-bold">{{ line.DisplayName }}</div>
            </div>
            <div *ngIf="!isHeader(line)" class="lm-active-order-details-field-block lm-active-order-details-field-block--amount"
                 [class.lm-active-order-details-field-block--indented]="isIndented(line)">
                <div class="lm-active-order-details-field-name"
                     [ngStyle]="{ 'font-weight': isTotal(line) ? '600' : '' }">{{ line.DisplayName }}:</div>
                <div class="lm-active-order-details-field-value"
                     [ngStyle]="{ 'font-weight': isTotal(line) ? '600' : '' }">{{ formatAmount(line) }}</div>
            </div>
        </ng-container>
    </div>
</div>
